import { EDITOR_TOOLS } from './editorTools';

export const GA_ID = 'UA-156923636-57';

/**
 * @param {string} url
 * @return {void}
 */
export const sendPageview = (url) => {
  window.gtag('config', GA_ID, {
    page_path: url,
  });
};

const sendTracking = (obj) => {
  const data = `category=${obj.category}&subcategory=${obj.subcategory}&event=${obj.event}&duration=3.14`;
  const url = 'https://exporter.pdfedit.pro/event';
  const params = {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    body: data,
    method: 'POST',
  };
  fetch(url, params);
};

// Осмысленные имена для deep-link-режимов редактора (?tool=X). Нужны, чтобы
// три карточки/пункта редактора ('/', '/?tool=sign', '/?tool=form') давали три
// РАЗЛИЧИМЫХ action в аналитике, а не схлопывались в один.
const TOOL_EVENT_ACTIONS = {
  [EDITOR_TOOLS.SIGN]: 'fill-sign',
  [EDITOR_TOOLS.FORM]: 'create-forms',
};

/**
 * Чистый различимый slug события из href для category 'click-to-open-pages'.
 * Правила: ?tool=X → имя из TOOL_EVENT_ACTIONS (иначе сам X); иначе pathname
 * без query/hash и ведущего '/'; корень '/' → 'edit-pdf'. Консистентен между
 * Card.js и Header.js, устойчив к query/hash в href.
 * @param {string} href
 * @return {string}
 */
export const hrefToEventAction = (href) => {
  const [pathPart, queryPart = ''] = String(href).split('?');
  const toolMatch = queryPart.split('#')[0].match(/(?:^|&)tool=([^&]+)/);

  if (toolMatch) {
    const tool = toolMatch[1];
    return TOOL_EVENT_ACTIONS[tool] || tool;
  }

  const path = pathPart.split('#')[0].replace(/^\//, '');

  return path || 'edit-pdf';
};

/**
 * @param {string} action
 * @param {string} [category]
 * @param {string} [label]
 * @return {void}
 */
export const sendEvent = ({ action, category, label }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
  });

  sendTracking({
    category: category,
    subcategory: action,
    event: label,
  });
};
// 'edit-pdf',
export const sendOpenPage = (url) => {
  const pages = ['split-pdf', 'rotate-pdf', 'compress-pdf', 'pdf-to-word',
    'pdf-to-excel', 'pdf-to-jpg', 'pdf-to-png', 'pdf-to-ppt', 'word-to-pdf', 'excel-to-pdf', 'html-to-pdf', 'jpg-to-pdf'];

  pages.forEach((el) => {
    if (url.match(el)) {
      return sendEvent({
        category: 'open-page',
        action: 'open',
        label: el,
      });
    }
  });
};
